export class ExpedientActionDto {
    comment?: string;
    action: string;

    constructor(act: string, com?: string) {
        this.comment = com;
        this.action = act;
    }
}
